module.exports = __webpack_public_path__ + "static/media/custom_color_elb.f95b1bdd.svg";